export default
{
    TITLE: 'title',
    BLOCKQUOTE: 'blockquote',
    SUBTITLE: 'subtitle',
    TEXT: 'text'
}



// WEBPACK FOOTER //
// ./src/scripts/constants/chef-block-types.js